<script>
    export default {
        name: 'SnackbarMixin',
        methods: {
            snackbarSuccess(message) {
                this.$store.commit('snackbar/setSnackbar', {message: message, color: 'success'});
            },
            snackbarError(message) {
                this.$store.commit('snackbar/setSnackbar', {message: message, color: 'error'});
            }
        }
    }
</script>
